/**
 * Download a file using Telegram Apps SDK
 */
export const downloadFileFromUrl = async (
  url: string,
  filename: string,
  downloadFile: any, // Type from @telegram-apps/sdk
): Promise<void> => {
  if (!downloadFile.isAvailable()) {
    throw new Error('Download not available');
  }

  await downloadFile(url, filename);
};
